import React from 'react';
import InfoModal from '../../components/common/InfoModal';

export default function UserInfoModal({ isOpen, onClose, user }) {
  if (!user) return null;

  const formatDate = (date) => {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleString();
    } catch {
      return date;
    }
  };

  return (
    <InfoModal isOpen={isOpen} onClose={onClose} title="User Details">
      <div className="space-y-2 text-gray-700">
        <p>
          <strong>Username:</strong> {user.username || 'N/A'}
        </p>
        <p>
          <strong>Email:</strong> {user.email || 'N/A'}
        </p>
        <p>
          <strong>Role:</strong> {user.role || 'N/A'}
        </p>
        <p>
          <strong>Created At:</strong> {formatDate(user.createdAt)}
        </p>
        <p>
          <strong>Updated At:</strong> {formatDate(user.updatedAt)}
        </p>
      </div>
    </InfoModal>
  );
}
